export default "__VITE_ASSET__Vk_3wFWY__"